// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import {session} from 'wix-storage';
import wixSite from 'wix-site';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

let path = wixLocation.path;
console.log("path is " + path[0]);
$w.onReady(function () {
	// TODO: write your page related code here...
		if (path[0] === "impressum") {
		$w('#impressumDot').show();
		$w('#uebermichDot').hide();
		$w('#angeboteDot').hide();
		$w('#werkstattDot').hide();
		$w('#agendaDot').hide();
		$w('#kontaktDot').hide();
		console.log("path is " + path[0]);
	}
});